import { ServicesList } from "@/features/services/components/ServicesList";
import { useCurrentBusiness } from "@/features/business/hooks/useCurrentBusiness";
import { Page, PageContent } from "@/shared/components/ui/Page";
import { PageHeader, PageHeaderAction } from "@/shared/components/ui/PageHeader";
import { useAppNavigation } from "@/shared/hooks/useAppNavigation";
import { useSearchParams } from "react-router-dom";

export function ServicesListPage() {
  const { businessId } = useCurrentBusiness();
  const { goToServiceAdd, goToServiceDetails } = useAppNavigation();
  const [searchParams, setSearchParams] = useSearchParams();
  const search = searchParams.get("search") ?? "";
  const rawStatus = searchParams.get("status");
  const status = rawStatus === "active" || rawStatus === "inactive" ? rawStatus : "all";
  const updateFilter = (name: string, value: string) => {
    setSearchParams((current) => {
      const next = new URLSearchParams(current);
      if (value && !(name === "status" && value === "all")) next.set(name, value);
      else next.delete(name);
      return next;
    }, { replace: true });
  };
  return (
    <Page>
      <PageHeader title="Services" actions={<PageHeaderAction aria-label="Add service" onClick={() => goToServiceAdd()}>Add</PageHeaderAction>} />
      <PageContent>
        <ServicesList
          key={businessId}
          onServiceClick={(service) => goToServiceDetails(service.id)}
          onAddService={() => goToServiceAdd()}
          search={search}
          status={status}
          onSearchChange={(value) => updateFilter("search", value)}
          onStatusChange={(value) => updateFilter("status", value)}
          onClearFilters={() => setSearchParams((current) => {
            const next = new URLSearchParams(current);
            next.delete("search");
            next.delete("status");
            return next;
          }, { replace: true })}
        />
      </PageContent>
    </Page>
  );
}
